import { RefreshOutlined } from '@material-ui/icons';
import { DownloadOutlined } from '@mui/icons-material';
import { Button, Grid, TextField } from '@mui/material';
import { useEffect, useState } from 'react'
import CritereTable from './CritereTable';
import { useQuery } from '../../../hooks/useQuery';

const CritereFiltre = ({ handleOpenFormDialog, handleCloseFormDialog, openForm }) => {
  const query = useQuery();
  const [filtre, setFiltre] = useState({
    critere: null,
    mot_cle: "",
    ID_CATEGORY: query.get("category"),
    refresh: 0,
  });

  const [excelExport, declenceExportToExcel] = useState(0);

  const downloadExcel = () => {
    declenceExportToExcel(excelExport + 1);
  }
  const handleOpenDialogForm = () => {
    handleOpenFormDialog();
  }

  const handleCloseDialogForm = () => {
    handleCloseFormDialog();
  }

  const handleRefreshData = () => {
    setFiltre({ ...filtre, refresh: filtre.refresh + 1 });
  }

  const handlechangeFiltre = (evt) => {
    const { name, value } = evt.target;
    setFiltre({ ...filtre, [name]: value });
  }

  useEffect(() => {
    if (query.get('id_groupe') > 0) {
      setFiltre({ ...filtre, ID_CATEGORY: query.get("id_groupe") })
    }
  }, [query.get("category")])

  return (
    <Grid display={"flex"} flexDirection={"column"} height={"70vh"}>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
        <TextField
          sx={{ width: 400 }}
          size='small'
          value={filtre.mot_cle}
          label="Mot clé"
          name='mot_cle'
          onChange={handlechangeFiltre}
          className="filtre_list"
        />
        <Button
          variant='outlined'
          className='filtre_list'
          onClick={handleRefreshData}
        >
          <RefreshOutlined />
        </Button>
        <Button
          variant='outlined'
          className='filtre_list'
          onClick={downloadExcel}
        >
          <DownloadOutlined /> Excel export
        </Button>
      </Grid>
      <Grid flexGrow={1} mt={3}>
        <CritereTable excelExport={excelExport} handleOpenDialog={handleOpenDialogForm} onCloseForm={handleCloseDialogForm} openForm={openForm} filtre={filtre} />
      </Grid>
    </Grid>
  )
}

export default CritereFiltre